// UI language preference. `niobe.lang` in localStorage is the LOCAL-FIRST CACHE LangProvider applies
// at startup; the member's choice itself lives server-side in GET/PATCH /v1/me/settings (AB#388), so
// it follows them across browsers, machines and Niobe Desktop — see lib/user-settings.ts for the
// sync. Mirrors lib/theme-prefs.ts: try/catch-wrapped localStorage, clamp-and-fallback on an
// invalid/missing value.

import type { Lang } from '../i18n'

const LANG_KEY = 'niobe.lang'

const LANGS: readonly Lang[] = ['en', 'fr']

export const DEFAULT_LANG: Lang = 'en'

export function getLang(): Lang {
  try {
    const v = localStorage.getItem(LANG_KEY)
    return (LANGS as readonly string[]).includes(v ?? '') ? (v as Lang) : DEFAULT_LANG
  } catch {
    return DEFAULT_LANG
  }
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem(LANG_KEY, lang)
  } catch {
    /* storage unavailable — ignore */
  }
}
